export default function initDownloadBlob(): void {
    const $btnDownloadBlob = document.querySelectorAll<HTMLElement>('.js-download-blob-ajax');
    $btnDownloadBlob.forEach($container => {
        new DownloadBlob($container);
    });
}

class DownloadBlob {
    $el: HTMLElement | null | undefined;
    
    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.init();
    }

    init(): void {
        if (this.$el) {
            this.$el.addEventListener('click', ()=> {
                const action = this.$el?.dataset.type ? 'ajax_download_' + this.$el?.dataset.type : '';
                const fileName = this.$el?.dataset.filename;
                const postId = this.$el?.dataset.post?.toString() || false;
                
                fetch(script_var.ajax_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        action: action,
                        id: postId.toString(),
                    }),
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`Erreur lors du téléchargement du fichier. (${response.status})`);
                        }
                        return response.blob();
                    })
                    .then(blob => {
                        const blobUrl = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = blobUrl;
                        if (fileName) {
                            link.download = fileName.toString();
                        }
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(blobUrl);
                    })
                    .catch(error => console.error(error));
            });
        }
    }
}